import BackendQuery from 'decentralized/BackendQuery.js';
import ipfs from 'decentralized/Ipfs.js';
import {SampleYoutube} from 'decentralized/EthereumEvents.js';
import {NewDiscogsSample} from 'decentralized/EthereumEvents.js';
import GuildSamplesContract from 'decentralized/contracts/GuildSamplesContract.js';
const contract = new GuildSamplesContract();

const cache = {};
export const getThumbnails = async (samples) => {
    let key = samples.join(',');
    if (key in cache) {
        return cache[key];
    }
    let videoIds = await new BackendQuery(contract.contractAddress)
        .from(SampleYoutube)
        .select('ipfsHash')
        .select('videoId')
        .whereIn('ipfsHash', samples)
        .executeQuery(true);

    let coverArts = await new BackendQuery(contract.contractAddress)
        .from(NewDiscogsSample)
        .select('sampleHash')
        .select('coverArtHash')
        .whereIn('sampleHash', samples)
        .executeQuery(true);

    let thumbnails = {};
    for (let r of videoIds) {
        thumbnails[r.ipfsHash] = 'https://img.youtube.com/vi/' + r.videoId + '/1.jpg';
    }
    for (let r of coverArts) {
        thumbnails[r.sampleHash] = ipfs.getHashUrl(r.coverArtHash);
    }
    cache[key] = thumbnails;
    return thumbnails;
}
